module.exports = require("./../../_gen/starling/extensions/PDParticleSystem");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/extensions/PDParticleSystem.js
// module id = 196
// module chunks = 0